<template>
  <div class="sign-up-page" :class="signupParent">
    <div v-if="!showBack" class="flex">
      <button
        type="button"
        class="signin-back btn-empty-wrapper"
        :disabled="disableBack"
        @click="clickHandler"
      >
        <Close icon="back"></Close>
      </button>
    </div>
    <div v-if="dynamicLogo" class="dynamic-logo">
      <img class="page-logo" :src="$getState('corporation')['dark_logo']" />
    </div>
    <Steps
      v-if="showSteps"
      :style="stepDynamicStyle"
      :active-step="$store.state.loginActiveStep"
    />
    <div v-if="$store.state.loginActiveStep === 'signUp'">
      <template v-if="$getState('startSign')">
        <h2
          class="page-title text-center text-28 text-text pt-7 tracking-tight"
        >
          <span class="text-content">{{ $t("Let's Get") }}</span>
          <span class="text-primary">{{ $t("Started!") }}</span>
        </h2>
        <p class="text-center bpage-subtitle text-12 text-light opacity-60">
          {{ $t("Choose how you want to sign up") }}
        </p>
        <SocialLogin />
        <div class="sign-up-or relative">
          <span class="relative color-text text-28 tracking-tight">{{
            $t("Or")
          }}</span>
        </div>
        <div class="sign-up-avatar-container" :class="avatarRequired">
          <PhotoUploader @addAvatar="addAvatar"></PhotoUploader>
          <ul class="formulate-input-errors text-center avatar-required">
            <li
              role="status"
              aria-live="polite"
              class="formulate-input-error text-center"
            >
              {{ $t("Profile picture required") }}
            </li>
          </ul>
        </div>
        <div class="form-items form-with-icons" :class="formStatus">
          <FormulateForm #default="{ hasErrors }" v-model="values">
            <div class="formulate-inner" :class="{ 'has-errors': hasErrors }">
              <div v-for="item in schema" :key="item.key">
                <Telephone
                  v-if="item.name === 'phone'"
                  clas="telephone"
                  v-model="values.phone"
                />
                <FormulateInput v-else v-bind="item" :hasErrors="hasErrors" />
              </div>
            </div>
          </FormulateForm>
        </div>
      </template>
      <template v-else>
        <AddAvatar />
      </template>
    </div>
    <div
      v-else-if="isUserInfo"
      class="flex-grow py-5 flex flex-col justify-center"
    >
      <UserInfo :profile="phoneProfile" @phone-verification="phoneVerfication">
      </UserInfo>
    </div>

    <div v-else-if="isPhoneVerification" class="pt-10">
      <span
        v-if="!!phoneProfile"
        @click="$setState('loginActiveStep', 'phone')"
      >
        <Close icon="back" />
      </span>
      <div v-if="isUpdatePhone" class="confirm-phone-number flex flex-col">
        <span @click="isUpdatePhone = false">
          <Close icon="back" />
        </span>
        <ConfirmPhoneNumber
          :phone="userPhone"
          :title="confirmTitle"
          content="Is it you ? we are sending OTP on this number. If you change the number it will be saved in your profile"
          @next="sendOTP"
        />
      </div>
      <PhoneVerification
        v-else
        through="login"
        :phone="userPhone"
        :show-update-phone="true"
        :endPoint="verifyEndPoint"
        para-two="to verify and activate your account"
        @update-phone="isUpdatePhone = true"
        @success="phoneVerified"
        @sendSMS="sendMessage"
      />
    </div>
    <Post
      post-type="cause"
      v-else-if="$store.state.loginActiveStep === 'cause'"
    />
    <Plaid :plaid="true" v-else-if="$store.state.loginActiveStep === 'bank'" />
    <FirstCard v-else-if="isFirstCard"></FirstCard>
    <div
      v-else-if="$store.state.loginActiveStep === 'donation'"
      class="signup-donation-settings"
      :class="donationClass"
    >
      <ChangeDonationPreferences :click-handler="complete" />
    </div>
    <Finished
      v-else-if="$store.state.loginActiveStep === 'finished'"
    ></Finished>
    <div v-else class="text-36 text-center font-bold mt-8">
      {{ $t("Please, reload app") }}
    </div>
    <LoaderModal />
    <div v-if="$store.state.loginActiveStep !== 'finished'">
      <Logout v-if="$user('id')" />
    </div>
  </div>
</template>

<script>
import Close from "../UI/Close";
import Steps from "./Steps";
import Social from "../Icons/Social";
import PhotoUploader from "../PhotoUploader/PhotoUploader";
import Loading from "../Loading/Loading";
import Finished from "../Finished/Finished";
import SocialLogin from "./SocialLogin";
import Post from "../Post/Post";
import AddAvatar from "../PhotoUploader/AddAvatar";
import ChangeDonationPreferences from "../Settings/ChangeDonationPreferences";
import Logout from "../Logout/Logout";
import Plaid from "./Plaid";
import LoaderModal from "../Modal/LoaderModal.vue";
import FirstCard from "../Card/FirstCard";
import UserInfo from "../../pages/UserProfile.vue";
import ConfirmPhoneNumber from "./ConfirmPhoneNumber.vue";
import PhoneVerification from "./PhoneVerification.vue";
import mixins from "../../config/mixins";
import Telephone from "../UI/Telephone.vue";
export default {
  name: "SignUp",
  mixins: [mixins.session],
  components: {
    Loading,
    FirstCard,
    Plaid,
    ChangeDonationPreferences,
    Logout,
    AddAvatar,
    Post,
    SocialLogin,
    Finished,
    Steps,
    Close,
    Social,
    PhotoUploader,
    LoaderModal,
    UserInfo,
    ConfirmPhoneNumber,
    PhoneVerification,
    Telephone
  },
  props: {
    clickHandler: {
      type: Function,
      default: () => {}
    }
  },
  data: function() {
    return {
      values: {
        phone: ""
      },
      hasAvatar: false,
      phone: "",
      isOpenDetailsPage: "",
      schema: [
        {
          key: "1",
          type: "email",
          name: "email",
          label: ".",
          placeholder: this.$t("Email"),
          validation: "required|email"
        },
        {
          key: "2",
          type: "text",
          name: "name",
          label: ".",
          placeholder: this.$t("Name"),
          validation: "required"
        },
        {
          key: "3",
          type: "tel",
          name: "phone",
          label: ".",
          placeholder: this.$t("Phone"),
          validation: "required|number|max:12,length|starts_with:+",
          help: "+16175551212"
        },
        {
          key: "4",
          type: "toggablePassword",
          name: "password",
          label: ".",
          placeholder: this.$t("Password"),
          validation: [
            ["required"],
            ["matches", /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/]
          ],
          "validation-messages": {
            matches: this.$t(
              "At least 8 characters, 1 uppercase letter, 1 number, 1 symbol"
            )
          },
          help: this.$t(
            "At least 8 characters, 1 uppercase letter, 1 number, 1 symbol"
          )
        },
        {
          key: "5",
          type: "toggablePassword",
          name: "confirm_password",
          label: ".",
          placeholder: this.$t("Confirm Password"),
          validation: "^required|confirm:password",
          validationName: "Password confirmation"
        },
        {
          type: "checkbox",
          name: "agree",
          label: "signUp",
          validation: "required",
          id: "agreeServices"
        },
        {
          key: "6",
          type: "customButton",
          label: this.$t("Sign Up"),
          formHandler: this.formHandler
        }
      ],
      avatar: "",
      startSign: true,
      updatedPhone: "",
      phoneProfile: null,
      isUpdatePhone: false
    };
  },

  mounted() {
    localStorage.setItem("signupSlider", "1");
    if (localStorage.getItem("signup")) {
      localStorage.removeItem("signup");
    }
    this.eventSignUp();
    this.WhichUser();

    if (this.$user("id")) {
      if (this.$user("has_avatar") === 0) {
        this.$setState("startSign", false);
      }
    }
  },
  computed: {
    phoneNumber() {
      return this.$user("phone") || this.values.phone;
    },
    signupParent() {
      return {
        "pb-16": this.pb16,
        px30: this.px30,
        "add-photo-page": this.addPhotopage
      };
    },
    pb16() {
      return this.$user("id");
    },
    px30() {
      return (
        this.$getState("loginActiveStep") === "signUp" ||
        this.$getState("loginActiveStep") === "verification"
      );
    },
    addPhotopage() {
      return (
        !this.$getState("startSign") &&
        this.$getState("loginActiveStep") === "signUp"
      );
    },
    showBack() {
      const nopes = ["phone", "verification", "cause", "finished"];
      return nopes.includes(this.$getState("loginActiveStep"));
    },
    disableBack() {
      return (
        !this.$getState("startSign") &&
        this.$getState("loginActiveStep") === "signUp"
      );
    },
    dynamicLogo() {
      return (
        this.$getState("corporation")["is"] &&
        this.$store.state.loginActiveStep === "signUp"
      );
    },
    showSteps() {
      const nopes = ["phone", "verification", "signUp"];
      return (
        this.$store.state.showSteps &&
        !this.$store.state.showAppFilters &&
        !nopes.includes(this.$getState("loginActiveStep"))
      );
    },
    avatarRequired() {
      return {
        "avatar-is-required": this.isAvatar
      };
    },
    isAvatar() {
      return (
        this.values.name &&
        this.values.email &&
        this.values.password &&
        this.values.confirm_password &&
        this.values.agree &&
        this.values.phone &&
        !this.avatar
      );
    },
    formStatus() {
      return {
        "form-enabled": this.isFormEnabled
      };
    },
    isFormEnabled() {
      return (
        this.values.name &&
        this.values.email &&
        this.values.password &&
        this.values.confirm_password &&
        this.values.agree &&
        this.values.phone &&
        this.avatar
      );
    },
    stepDynamicStyle() {
      const obj = {
        "padding-top": !this.showBack ? `${8}rem` : `${2}rem`
      };
      return obj;
    },
    isUserInfo() {
      return this.$store.state.loginActiveStep == "phone";
    },
    isPhoneVerification() {
      return this.$getState("loginActiveStep") == "verification";
    },
    userPhone() {
      return (
        (this.phoneProfile && this.phoneProfile.phone) || this.updatedPhone || this.$user('phone')
      );
    },
    confirmTitle() {
      return ` <span class="text-primary">Confirm</span> 
        <span class="text-content">Phone Number</span>`;
    },
    isFirstCard() {
      const possible = ["card", "addCard", "authorize", "provide"];
      return possible.includes(this.$store.state.loginActiveStep);
    },
    donationaClass() {
      return {
        px30: this.$store.state.loginActiveStep === "donation"
      };
    },
    verifyEndPoint() {
      return this.updatedPhone ? "/user/verify_otp" : "/user/checksms";
    }
  },
  methods: {
    checkPhone: function(number, phoneObject) {
      if (phoneObject.number !== undefined) {
        this.values.phone = phoneObject.number;
      } else {
        this.values.phone = number;
      }
    },
    formHandler: function() {
      window.scrollTo(0, 0);
      this.values.avatar = this.avatar;
      this.values.referral = this.$getState("referral");
      this.values.hash = this.$getState("hash");

      this.$http.post("user/signup", this.values).then(data => {
        if (data && data.status !== undefined && data.status) {
          if (localStorage.getItem("signup")) {
            localStorage.removeItem("signup");
          }
          this.$setLocalStorage("thriveAppTokenRemember", false);
          this.$setLocalStorage("thriveAppTokenInitTime", +new Date());
          this.$setLocalStorage("thriveAppToken", data.data.token);
          this.$token.value = data.data.token;
          this.$http.defaults.headers["Authorization"] =
            "Bearer " + data.data.token;
          this.$silentHttp.defaults.headers["Authorization"] =
            "Bearer " + data.data.token;
          this.$setState("user", data.data.user);
          this.$setState("appUrl", data.data.app_url);

          if (this.$user("has_avatar") === 1) {
            this.$setState("loginActiveStep", "verification");
            this.$setState("loginSteps", { signUp: true });
          } else {
            this.$setState("startSign", false);
          }
        }
      });
    },
    addAvatar: function(img) {
      this.avatar = img;
      if (img) this.hasAvatar = true;
    },
    eventSignUp: function() {
      this.$silentHttp.post("user/event_signup", {
        hash: this.$getState("hash")
      });
    },
    WhichUser: function() {
      this.$http.post("user/useronline");
    },
    complete: function() {
      this.$setState("loginActiveStep", "finished");
    },
    async saveProfile(phone) {
      const response = await this.$http.post(
        "user/saveprofile",
        this.phoneProfile
      );
      if (!response.status) return;
      this.$setState("loginActiveStep", "verification");
      await this.sendSMS(phone);
    },
    async phoneVerfication(values) {
      this.phoneProfile = values;
      const { phone } = this.phoneProfile;
      await this.saveProfile(phone);
    },
    async sendOTP(phone) {
      const paylaod = {
        phone
      };
      const res = await this.$http.post("user/send_otp", paylaod);
      if (!res.status) return;
      this.updatedPhone = phone;
      this.isUpdatePhone = false;
    },
    sendMessage(phone) {
      this.updatedPhone ? this.sendOTP(phone) : this.sendSMS(phone);
    },
    async sendSMS(phone) {
      const paylaod = {
        phone
      };
      const res = await this.$http.post("user/checkphone", paylaod);
      res.status ? this.$toastr.s("Code is sent on your registered Mobile Phone") : "";
    },
    phoneVerified() {
      this.$store.state.user.phone = this.userPhone;
      this.checkUser();
    }
  }
};
</script>
<style scoped>
.confirm-phone-number {
  height: calc(100vh - 110px);
}
</style>
